module.exports = __webpack_public_path__ + "static/img/Visualization3.bdf33236.png";